import axios, { AxiosResponse } from 'axios';
import { getDataUrl, reportErrorSentry } from 'src/bff';
import { HorariosCallMe } from 'src/types';

export const getHorariosCallMe = async (): Promise<HorariosCallMe> => {
	try {
		const dataUrl = getDataUrl();

		const response: AxiosResponse<{ horarios: HorariosCallMe }> = await axios.get(`${dataUrl}/getHorariosCallMeNow`);
		return response.data.horarios;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};
